<template>
  <div data-testid="filter-dropdown-with-search">
    <v-autocomplete
      v-model="selectedValue"
      :items="items"
      :item-text="itemText"
      :item-value="itemValue"
      :label="label"
      dense
      outlined
      hide-details
      clearable
      :placeholder="placeholder"
      class="filter-dropdown-search"
      data-testid="filter-dropdown-with-search__autocomplete"
    >
      <template v-slot:prepend-inner data-testid="filter-dropdown-with-search__prepend-inner">
        <v-icon class="search-icon">mdi-filter-outline</v-icon>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  name: 'FilterDropdownWithSearch',
  
  props: {
    // The selected value (use v-model)
    value: {
      type: [String, Number, Object],
      default: null
    },
    // Array of items to display in dropdown
    items: {
      type: Array,
      default: () => []
    },
    // Property name to display as text
    itemText: {
      type: String,
      default: 'text'
    },
    // Property name to use as value
    itemValue: {
      type: String,
      default: 'value'
    },
    // Label for the dropdown
    label: {
      type: String,
      default: 'Filter'
    },
    // Placeholder text
    placeholder: {
      type: String,
      default: 'Search...'
    }
  },

  computed: {
    selectedValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    }
  }
};
</script>

<style scoped>
.filter-dropdown-search {
  max-width: 100%;
}

::v-deep .filter-dropdown-search .v-input__control {
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

::v-deep .filter-dropdown-search .v-input__slot {
  border-radius: 8px !important;
  transition: box-shadow 0.3s ease;
}

::v-deep .filter-dropdown-search .v-input__slot:hover {
  box-shadow: 0 3px 8px #183440
}

::v-deep .filter-dropdown-search.v-input--is-focused .v-input__slot {
  box-shadow: 0 4px 12px #183440;
}

::v-deep .filter-dropdown-search fieldset {
  border-radius: 8px;
}

::v-deep .filter-dropdown-search .v-input__prepend-inner {
  margin-top: 2px !important;
  align-self: center !important;
}

::v-deep .filter-dropdown-search .v-input__append-inner {
  margin-top: 0px !important;
  align-self: center !important;
  padding-top: 0px !important;
}

::v-deep .filter-dropdown-search .v-input__icon {
  align-items: center !important;
  justify-content: center !important;
}

::v-deep .filter-dropdown-search .v-input__icon--append .v-icon {
  margin-top: 0px !important;
}

::v-deep .filter-dropdown-search .v-input__icon--clear .v-icon {
  margin-top: 0px !important;
}

.search-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
